import { useEffect, useState } from 'react';
import { SERVER_REACHABILITY_EVENT } from '@/constants/events';
import { isServerUnreachable } from '@/services/api/serverReachability';

/**
 * `true` mientras la API no responde a nivel de red (≥2 fallos consecutivos;
 * ver services/api/serverReachability). Complementa a `useOnlineStatus`: aquel
 * detecta que el DISPOSITIVO no tiene conexión; este, que el SERVIDOR no
 * contesta aunque haya internet (caída del proveedor, DNS, edge…).
 */
export function useServerUnreachable(): boolean {
  const [unreachable, setUnreachable] = useState<boolean>(isServerUnreachable);

  useEffect(() => {
    const handler = (event: Event) =>
      setUnreachable(Boolean((event as CustomEvent).detail?.unreachable));
    window.addEventListener(SERVER_REACHABILITY_EVENT, handler);
    return () => window.removeEventListener(SERVER_REACHABILITY_EVENT, handler);
  }, []);

  return unreachable;
}

export default useServerUnreachable;
